export default function ChapterDetail10(props) {
  document.title = props.text + " | Arisu";
  
	return (
    <>
      <p className="indent-8">
        The Mock Turtle sighed deeply, and drew the back of one flapper across his
        eyes. He looked at Alice, and tried to speak, but for a minute or two sobs
        choked his voice. “Same as if he had a bone in his throat,” said
        the Gryphon: and it set to work shaking him and punching him in the back. At
        last the Mock Turtle recovered his voice, and, with tears running down his
        cheeks, he went on again:—
      </p>
      <p className="indent-8">
        “You may not have lived much under the sea—” (“I
        haven’t,” said Alice)—“and perhaps you were never even
        introduced to a lobster—” (Alice began to say “I once
        tasted—” but checked herself hastily, and said “No,
        never”) “—so you can have no idea what a delightful thing a
        Lobster Quadrille is!”
      </p>
      <p className="indent-8">
        “No, indeed,” said Alice. “What sort of a dance is it?”
      </p>
      <p className="indent-8">
        “Why,” said the Gryphon, “you first form into a line along
        the sea-shore—”
      </p>
      <p className="indent-8">
        “Two lines!” cried the Mock Turtle. “Seals, turtles, salmon,
        and so on; then, when you’ve cleared all the jelly-fish out of the
        way—”
      </p>
      <p className="indent-8">
        “<i>That</i> generally takes some time,” interrupted the Gryphon.
      </p>
      <p className="indent-8">
        “—you advance twice—”
      </p>
      <p className="indent-8">
        “Each with a lobster as a partner!” cried the Gryphon.
      </p>
      <p className="indent-8">
        “Of course,” the Mock Turtle said: “advance twice, set to
        partners—”
      </p>
      <p className="indent-8">
        “—change lobsters, and retire in same order,” continued the
        Gryphon.
      </p>
      <p className="indent-8">
        “Then, you know,” the Mock Turtle went on, “you throw
        the—”
      </p>
      <p className="indent-8">
        “The lobsters!” shouted the Gryphon, with a bound into the air.
      </p>
      <p className="indent-8">
        “—as far out to sea as you can—”
      </p>
      <p className="indent-8">
        “Swim after them!” screamed the Gryphon.
      </p>
      <p className="indent-8">
        “Turn a somersault in the sea!” cried the Mock Turtle, capering
        wildly about.
      </p>
      <p className="indent-8">
        “Change lobsters again!” yelled the Gryphon at the top of its
        voice.
      </p>
      <p className="indent-8">
        “Back to land again, and that’s all the first figure,” said
        the Mock Turtle, suddenly dropping his voice; and the two creatures, who had
        been jumping about like mad things all this time, sat down again very sadly and
        quietly, and looked at Alice.
      </p>
      <p className="indent-8">
        “It must be a very pretty dance,” said Alice timidly.
      </p>
      <p className="indent-8">
        “Would you like to see a little of it?” said the Mock Turtle.
      </p>
      <p className="indent-8">
        “Very much indeed,” said Alice.
      </p>
      <p className="indent-8">
        “Come, let’s try the first figure!” said the Mock Turtle to
        the Gryphon. “We can do without lobsters, you know. Which shall
        sing?”
      </p>
      <p className="indent-8">
        “Oh, <i>you</i> sing,” said the Gryphon. “I’ve
        forgotten the words.”
      </p>
      <p className="indent-8">
        So they began solemnly dancing round and round Alice, every now and then
        treading on her toes when they passed too close, and waving their forepaws to
        mark the time, while the Mock Turtle sang this, very slowly and sadly:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“Will you walk a little faster?” said a whiting to a snail.</p>
        <p>“There’s a porpoise close behind us, and he’s treading on my tail.</p>
        <p>See how eagerly the lobsters and the turtles all advance!</p>
        <p>They are waiting on the shingle—will you come and join the dance?</p>
        <p>Will you, won’t you, will you, won’t you, will you join the dance?</p>
        <p className="mb-2">Will you, won’t you, will you, won’t you, won’t you join the dance?</p>
        <p>“You can really have no notion how delightful it will be</p>
        <p>When they take us up and throw us, with the lobsters, out to sea!”</p>
        <p>But the snail replied “Too far, too far!” and gave a look askance—</p>
        <p>Said he thanked the whiting kindly, but he would not join the dance.</p>
        <p>Would not, could not, would not, could not, would not join the dance.</p>
        <p className="mb-2">Would not, could not, would not, could not, could not join the dance.</p>
        <p>“What matters it how far we go?” his scaly friend replied.</p>
        <p>“There is another shore, you know, upon the other side.</p>
        <p>The further off from England the nearer is to France—</p>
        <p>Then turn not pale, beloved snail, but come and join the dance.</p>
        <p>Will you, won’t you, will you, won’t you, will you join the dance?</p>
        <p className="mb-2">Will you, won’t you, will you, won’t you, won’t you join the dance?”</p>
      </div>
      <p className="indent-8">
        “Thank you, it’s a very interesting dance to watch,” said
        Alice, feeling very glad that it was over at last: “and I do so like that
        curious song about the whiting!”
      </p>
      <p className="indent-8">
        “Oh, as to the whiting,” said the Mock Turtle,
        “they—you’ve seen them, of course?”
      </p>
      <p className="indent-8">
        “Yes,” said Alice, “I’ve often seen them at
        dinn—” she checked herself hastily.
      </p>
      <p className="indent-8">
        “I don’t know where Dinn may be,” said the Mock Turtle,
        “but if you’ve seen them so often, of course you know what
        they’re like.”
      </p>
      <p className="indent-8">
        “I believe so,” Alice replied thoughtfully. “They have their
        tails in their mouths—and they’re all over crumbs.”
      </p>
      <p className="indent-8">
        “You’re wrong about the crumbs,” said the Mock Turtle:
        “crumbs would all wash off in the sea. But they <i>have</i> their tails
        in their mouths; and the reason is—” here the Mock Turtle yawned
        and shut his eyes.—“Tell her about the reason and all that,”
        he said to the Gryphon.
      </p>
      <p className="indent-8">
        “The reason is,” said the Gryphon, “that they <i>would</i> go
        with the lobsters to the dance. So they got thrown out to sea. So they had to
        fall a long way. So they got their tails fast in their mouths. So they
        couldn’t get them out again. That’s all.”
      </p>
      <p className="indent-8">
        “Thank you,” said Alice, “it’s very interesting. I
        never knew so much about a whiting before.”
      </p>
      <p className="indent-8">
        “I can tell you more than that, if you like,” said the Gryphon.
        “Do you know why it’s called a whiting?”
      </p>
      <p className="indent-8">
        “I never thought about it,” said Alice. “Why?”
      </p>
      <p className="indent-8">
        “<i>It does the boots and shoes</i>,” the Gryphon replied very
        solemnly.
      </p>
      <p className="indent-8">
        Alice was thoroughly puzzled. “Does the boots and shoes!” she
        repeated in a wondering tone.
      </p>
      <p className="indent-8">
        “Why, what are <i>your</i> shoes done with?” said the Gryphon.
        “I mean, what makes them so shiny?”
      </p>
      <p className="indent-8">
        Alice looked down at them, and considered a little before she gave her answer.
        “They’re done with blacking, I believe.”
      </p>
      <p className="indent-8">
        “Boots and shoes under the sea,” the Gryphon went on in a deep
        voice, “are done with a whiting. Now you know.”
      </p>
      <p className="indent-8">
        “And what are they made of?” Alice asked in a tone of great
        curiosity.
      </p>
      <p className="indent-8">
        “Soles and eels, of course,” the Gryphon replied rather
        impatiently: “any shrimp could have told you that.”
      </p>
      <p className="indent-8">
        “If I’d been the whiting,” said Alice, whose thoughts were
        still running on the song, “I’d have said to the porpoise,
        ‘Keep back, please: we don’t want <i>you</i> with us!’”
      </p>
      <p className="indent-8">
        “They were obliged to have him with them,” the Mock Turtle said:
        “no wise fish would go anywhere without a porpoise.”
      </p>
      <p className="indent-8">
        “Wouldn’t it really?” said Alice in a tone of great surprise.
      </p>
      <p className="indent-8">
        “Of course not,” said the Mock Turtle: “why, if a fish came
        to <i>me</i>, and told me he was going a journey, I should say ‘With what
        porpoise?’”
      </p>
      <p className="indent-8">
        “Don’t you mean ‘purpose’?” said Alice.
      </p>
      <p className="indent-8">
        “I mean what I say,” the Mock Turtle replied in an offended tone.
        And the Gryphon added “Come, let’s hear some of <i>your</i>
        adventures.”
      </p>
      <p className="indent-8">
        “I could tell you my adventures—beginning from this morning,”
        said Alice a little timidly: “but it’s no use going back to
        yesterday, because I was a different person then.”
      </p>
      <p className="indent-8">
        “Explain all that,” said the Mock Turtle.
      </p>
      <p className="indent-8">
        “No, no! The adventures first,” said the Gryphon in an impatient
        tone: “explanations take such a dreadful time.”
      </p>
      <p className="indent-8">
        So Alice began telling them her adventures from the time when she first saw the
        White Rabbit. She was a little nervous about it just at first, the two
        creatures got so close to her, one on each side, and opened their eyes and
        mouths so <i>very</i> wide, but she gained courage as she went on. Her
        listeners were perfectly quiet till she got to the part about her repeating
        “<i>You are old, Father William</i>,” to the Caterpillar, and the
        words all coming different, and then the Mock Turtle drew a long breath, and
        said “That’s very curious.”
      </p>
      <p className="indent-8">
        “It’s all about as curious as it can be,” said the Gryphon.
      </p>
      <p className="indent-8">
        “It all came different!” the Mock Turtle repeated thoughtfully.
        “I should like to hear her try and repeat something now. Tell her to
        begin.” He looked at the Gryphon as if he thought it had some kind of
        authority over Alice.
      </p>
      <p className="indent-8">
        “Stand up and repeat ‘’<i>Tis the voice of the
          sluggard</i>,’” said the Gryphon.
      </p>
      <p className="indent-8">
        “How the creatures order one about, and make one repeat lessons!”
        thought Alice; “I might as well be at school at once.” However, she
        got up, and began to repeat it, but her head was so full of the Lobster
        Quadrille, that she hardly knew what she was saying, and the words came very
        queer indeed:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“’Tis the voice of the Lobster; I heard him declare,</p>
        <p>“You have baked me too brown, I must sugar my hair.”</p>
        <p>As a duck with its eyelids, so he with his nose</p>
        <p className="mb-2">Trims his belt and his buttons, and turns out his toes.”</p>
        <p>[later editions continued as follows</p>
        <p>When the sands are all dry, he is gay as a lark,</p>
        <p>And will talk in contemptuous tones of the Shark,</p>
        <p>But, when the tide rises and sharks are around,</p>
        <p className="mb-2">His voice has a timid and tremulous sound.]</p>
      </div>
      <p className="indent-8">
        “That’s different from what <i>I</i> used to say when I was a
        child,” said the Gryphon.
      </p>
      <p className="indent-8">
        “Well, I never heard it before,” said the Mock Turtle; “but
        it sounds uncommon nonsense.”
      </p>
      <p className="indent-8">
        Alice said nothing; she had sat down with her face in her hands, wondering if
        anything would <i>ever</i> happen in a natural way again.
      </p>
      <p className="indent-8">
        “I should like to have it explained,” said the Mock Turtle.
      </p>
      <p className="indent-8">
        “She can’t explain it,” said the Gryphon hastily. “Go
        on with the next verse.”
      </p>
      <p className="indent-8">
        “But about his toes?” the Mock Turtle persisted. “How
        <i>could</i> he turn them out with his nose, you know?”
      </p>
      <p className="indent-8">
        “It’s the first position in dancing.” Alice said; but was
        dreadfully puzzled by the whole thing, and longed to change the subject.
      </p>
      <p className="indent-8">
        “Go on with the next verse,” the Gryphon repeated impatiently:
        “it begins ‘<i>I passed by his garden</i>.’”
      </p>
      <p className="indent-8">
        Alice did not dare to disobey, though she felt sure it would all come wrong,
        and she went on in a trembling voice:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“I passed by his garden, and marked, with one eye,</p>
        <p className="mb-2">How the Owl and the Panther were sharing a pie—”</p>
        <p>[later editions continued as follows</p>
        <p>The Panther took pie-crust, and gravy, and meat,</p>
        <p>While the Owl had the dish as its share of the treat.</p>
        <p>When the pie was all finished, the Owl, as a boon,</p>
        <p>Was kindly permitted to pocket the spoon:</p>
        <p>While the Panther received knife and fork with a growl,</p>
        <p className="mb-2">And concluded the banquet—]</p>
      </div>
      <p className="indent-8">
        “What <i>is</i> the use of repeating all that stuff,” the Mock
        Turtle interrupted, “if you don’t explain it as you go on?
        It’s by far the most confusing thing <i>I</i> ever heard!”
      </p>
      <p className="indent-8">
        “Yes, I think you’d better leave off,” said the Gryphon: and
        Alice was only too glad to do so.
      </p>
      <p className="indent-8">
        “Shall we try another figure of the Lobster Quadrille?” the Gryphon
        went on. “Or would you like the Mock Turtle to sing you a song?”
      </p>
      <p className="indent-8">
        “Oh, a song, please, if the Mock Turtle would be so kind,” Alice
        replied, so eagerly that the Gryphon said, in a rather offended tone,
        “Hm! No accounting for tastes! Sing her ‘<i>Turtle Soup</i>,’
        will you, old fellow?”
      </p>
      <p className="indent-8">
        The Mock Turtle sighed deeply, and began, in a voice sometimes choked with
        sobs, to sing this:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“Beautiful Soup, so rich and green,</p>
        <p>Waiting in a hot tureen!</p>
        <p>Who for such dainties would not stoop?</p>
        <p>Soup of the evening, beautiful Soup!</p>
        <p>Soup of the evening, beautiful Soup!</p>
        <p className="indent-8">Beau—ootiful Soo—oop!</p>
        <p className="indent-8">Beau—ootiful Soo—oop!</p>
        <p>Soo—oop of the e—e—evening,</p>
        <p className="indent-8 mb-2">Beautiful, beautiful Soup!</p>
        <p>“Beautiful Soup! Who cares for fish,</p>
        <p>Game, or any other dish?</p>
        <p>Who would not give all else for two p</p>
        <p>ennyworth only of beautiful Soup?</p>
        <p>Pennyworth only of beautiful Soup?</p>
        <p className="indent-8">Beau—ootiful Soo—oop!</p>
        <p className="indent-8">Beau—ootiful Soo—oop!</p>
        <p>Soo—oop of the e—e—evening,</p>
        <p className="indent-8 mb-2">Beautiful, beauti—FUL SOUP!”</p>
      </div>
      <p className="indent-8">
        “Chorus again!” cried the Gryphon, and the Mock Turtle had just
        begun to repeat it, when a cry of “The trial’s beginning!”
        was heard in the distance.
      </p>
      <p className="indent-8">
        “Come on!” cried the Gryphon, and, taking Alice by the hand, it
        hurried off, without waiting for the end of the song.
      </p>
      <p className="indent-8">
        “What trial is it?” Alice panted as she ran; but the Gryphon only
        answered “Come on!” and ran the faster, while more and more faintly
        came, carried on the breeze that followed them, the melancholy words:—
      </p>
      <div className="grid justify-center">
        <p className="mt-2">“Soo—oop of the e—e—evening,</p>
        <p className="indent-8">Beautiful, beautiful Soup!”</p>
      </div>
    </>
  )
}